$('.customer-reviews-inner-slider').slick({
  centerMode: true,
  centerPadding: '0px',
  slidesToShow: 3,
  speed: 500,
  arrows: true,
    prevArrow: `<button type="button" class="slick-prev">
                  <svg width="24" height="24" viewBox="0 0 24 24">
                    <path d="M15 18L9 12L15 6" stroke="black" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>`,
    nextArrow: `<button type="button" class="slick-next">
                  <svg width="24" height="24" viewBox="0 0 24 24">
                    <path d="M9 6L15 12L9 18" stroke="black" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>`,
  responsive: [
    {
      breakpoint: 989,
      settings: {        
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 2
      }
    },
    {
      breakpoint: 749,
      settings: {
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 2
      }
    }
  ]
});